import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuctionLimitDetailTab from './AuctionLimitDetailTab';
import useDetailHandler from '../../hooks/useDetailHandler';
import { auctionLimitPropertiesType, auctionLimitType } from '../../types';
import './_styles_/AuctionLimitRow.css';
import { onActionKey } from '../../utils';
import Number from '../Number';

AuctionLimitRow.propTypes = {
    auctionLimit: auctionLimitType.isRequired,
    auctionLimitProps: auctionLimitPropertiesType.isRequired,
};

function AuctionLimitRow(props) {
    const {
        auctionLimit,
        auctionLimitProps,
    } = props;
    const { isDetailVisible, toggleDetail, onDetailDelete } = useDetailHandler(auctionLimit.id);
    return (
        <>
            <div className="rich-list-row auction-limit-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="auction-limit-header--values--member">{auctionLimit.member.memberId}</div>
                <div className="auction-limit-header--values--product">{auctionLimit.product.productId}</div>
                <div className="auction-limit-header--values--limit"><Number value={auctionLimit.limit} /></div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <AuctionLimitDetailTab
                    auctionLimit={auctionLimit}
                    auctionLimitProps={auctionLimitProps}
                    onDetailDelete={onDetailDelete}
                />
            )}
        </>
    );
}

export default AuctionLimitRow;
